import React, { useState } from 'react';
import NavDropdown from './nav-dropdown';
import ChevronDown from '../../../images/chevron_down_black.svg';
import ChevronUp from '../../../images/chevron_up_black.svg';
import useDelayUnmount from '../../../hooks/useDelayUnmount';

const NavDropdownToggle = ({ label, items }) => {
  const [isMounted, setIsMounted] = useState(false);
  const showDropdown = useDelayUnmount({isMounted, delayTime: 250});
  const toggleDropdown = () => setIsMounted(prev => !prev);

  const triggerRef = React.useRef(null);

  const mainItems = items.filter(item => (item.childItems?.nodes?.length === 0));
  const secondaryItemsParent = items.find(item => item.childItems && item.childItems.nodes.length > 0);
  const secondaryLabel = secondaryItemsParent?.label;
  const secondaryItems = secondaryItemsParent?.childItems?.nodes;

  return (
    <div className='nav-dropdown-trigger'>
      <div ref={triggerRef} className={`toggle ${isMounted ? 'selected' : ''}`} onClick={toggleDropdown}>
        {label}
        <img className='chevron' src={isMounted ? ChevronUp : ChevronDown} alt={isMounted ? "arrow up" : "arrow down"} />
      </div>
      {showDropdown && 
        <NavDropdown triggerRef={triggerRef} isMounted={isMounted} setIsMounted={setIsMounted} mainItems={mainItems} secondaryItems={secondaryItems} secondaryLabel={secondaryLabel} />
      }
    </div>
  )
}

export default NavDropdownToggle;